<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <path
      :fill="color"
      d="M9 0c4.97 0 9 4.03 9 9s-4.03 9-9 9c-3.976 0-7.447-2.602-8.601-6.344-.082-.263.066-.543.33-.625.264-.081.544.067.625.33C2.38 14.688 5.466 17 9 17c4.418 0 8-3.582 8-8s-3.582-8-8-8C5.695 1 2.784 3.022 1.581 6H5.5c.245 0 .45.177.492.41L6 6.5c0 .245-.177.45-.41.492L5.5 7l-4.396.002c-.115.067-.257.088-.394.047-.04-.012-.076-.028-.11-.047L.5 7c-.245 0-.45-.177-.492-.41L0 6.5v-5c0-.276.224-.5.5-.5.245 0 .45.177.492.41L1 1.5v3.372C2.514 1.94 5.567 0 9 0zm.5 3c.245 0 .45.177.492.41L10 3.5v5.732l2.777 1.852c.205.136.276.397.182.614l-.043.08c-.136.204-.397.275-.614.181l-.08-.043-3-2c-.11-.074-.186-.189-.212-.317L9 9.5v-6c0-.276.224-.5.5-.5z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
